.load ide.dl
.load highlight.dl
.load astViz.dl
.load scopeGraphViz.dl
# .load relationGraphViz.dl
